const translations = {
    endDatePlaceholder: 'MM/DD/YYYY',
    startDatePlaceholder: 'MM/DD/YYYY'
};

export default translations;
